import { SiteConfig } from './types'

const monitorSk: SiteConfig = {
  variant: 'monitor-sk',
  routePrefix: 'monitor',

  features: {
    shorts: false,
    stats: false,
    formulasImageUrl: null,
  },

  subjects: [
    { id: 'monitor-sjl', label: 'Slovenský jazyk a literatúra' },
    { id: 'monitor-mat', label: 'Matematika' },
  ],

  payments: {
    periods: [],
    currentPeriodId: '',
    currentProductId: '',
    checkoutBaseUrl: '',
  },

  firebase: {
    // TODO: register a separate web app in Firebase console for monitor.kuramatura.sk
    appId: '1:443202482105:web:aa55968051f16ee0c51068',
    measurementId: 'G-XMCERXBMJ6',
  },

  siteUrl: 'https://monitor.kuramatura.sk',
  siteTitle: 'Kura Monitor',
  siteDescription: 'Interaktívna Online Príprava na Monitor',

  contact: {
    email: 'contact@kuramatura.eu',
    privacyUrl: '/legal/privacy-policy.txt',
    donateUrl: 'https://donate.stripe.com/3cscQGc7f3NX5DW288',
  },

  labels: {
    nav: {
      tests: 'Testy',
      shorts: 'Shorts',
      stats: 'Štatistiky ★',
      previous: 'Predchádzajúce testy',
      about: 'O Projekte',
      donate: 'Podporiť',
      footer: 'So súhlasom NiVam',
    },

    headers: {
      tests: 'PREDMET',
      shorts: 'SHORTS',
      stats: 'ŠTATISTIKY',
    },

    test: {
      start: 'ZAČAŤ TEST',
      end: 'Ukončiť test',
      back: 'Späť na výber testov',
      correctAnswers: 'Správne odpovede:',
      allCorrectAnswers: 'Všetky správne odpovede:',
      noCorrectAnswer: 'Nemá správnu odpoveď',
      notCaseSensitive: 'Na veľkosti písmen nezáleží',
      correctAnswerPrefix: 'Správna odpoveď:',
      questionCount: 'otázok',
      durationMinutes: 'minút',
      loginPrompt: 'Pre ukladanie výsledkov testov a štatistiky sa prihláste.',
      loginButton: 'Prihlásiť sa',
      showFormulas: 'Zobraziť vzorce',
      hideFormulas: 'Skryť vzorce',
    },

    testSidebar: {
      duration: 'Trvalo',
      correct: 'Správne',
      timeLeft: 'Zostáva',
      answered: 'Vyplnené',
    },

    shorts: {
      correct: 'Správne',
      incorrect: 'Nesprávne',
      next: 'Ďalšia Otázka',
      finish: 'Koniec',
      subjectDescription: 'rýchly kvízový formát Monitoru',
      pickerDescription: 'Rýchly kvízový formát testovania pre Monitor',
    },

    stats: {
      heading: 'Štatistiky',
      periodLabel: 'Obdobie',
      subjectLabel: 'Predmet',
      cumulativeLabel: 'Kumulatívne',
      allSubjects: 'Všetko',
      periods: {
        last7: 'Posledný týždeň',
        last14: 'Posledné dva týždne',
        last30: 'Posledný mesiac',
        all: 'Celé obdobie',
      },
      modes: {
        cumulative: 'Kumulatívne',
        nonCumulative: 'Nekumulatívne',
      },
      graphs: {
        success: 'Úspešnosť',
        tests: 'Počet vyplnených testov',
        totalQuestions: 'Počet zadaných otázok',
        answered: 'Počet zodpovedaných otázok',
        correct: 'Počet správnych odpovedí',
      },
    },

    auth: {
      loading: 'Načítava sa...',
      statsPrompt: 'Pre prístup k štatistikám sa prihláste.',
      testPrompt: 'Pre ukladanie výsledkov testov a štatistiky sa prihláste.',
      button: 'Prihlásiť sa',
      emailSent: 'Email odoslaný',
      emailSentBody: 'Odkaz na prihlásenie bol odoslaný na tvoju emailovú adresu.',
      sendingEmail: 'Odosielam email',
      waiting: 'Čakaj prosím...',
      signInTitle: 'Prihlás sa pomocou emailu',
      signInBody: 'Na tvoju emailovú adresu ti pošleme odkaz, ktorým sa môžeš prihlásiť.',
      submitButton: 'Odoslať',
      signingInTitle: 'Prebieha prihlasovanie',
      emailNotFound: 'Email nenájdený',
    },

    donate: {
      prompt: 'Užívaš?',
      footer: 'menej ako 50 centov sa nedá. kúp si rožok.',
    },

    payment: {
      linkCopied: 'Odkaz máš skopírovaný',
      sendToParent: 'Poslať rodičom',
      payNow: 'Zaplatiť teraz',
    },

    explain: {
      loginPrompt: 'Pre vysvetlenia sa prihláste.',
      limitReached: 'Dnešný limit vysvetlení bol vyčerpaný.',
      purchasePrompt: 'Odomknúť neobmedzené vysvetlenia',
      freeUsesLeft: 'Ešte {{count}} bezplatných vysvetlení dnes',
      disclaimer: 'Generované AI — môže obsahovať chyby',
      followUpPlaceholder: 'Opýtaj sa ďalej...',
    },

    landing: {
      headline: 'Interaktívna príprava na Monitor',
      description: [
        'Rýchlo. Interaktívne. Efektívne.',
        'Bez zbytočných papierov.',
        'Sleduj svoj pokrok, zlepši sa!',
      ],
      cta: ['Netlačíš.', 'Neplačeš.', 'Testuješ.'],
      button: 'Testuj',
    },

    about: {
      title: 'O nás',
      description: 'Vytvorené ako alternatíva ku status quo - papierové testy a manuálne opravovanie.',
      contactLabel: 'kontakt',
      privacyLabel: 'súkromie',
      privacyText: 'pravidlá ochrany súkromia',
      donateButton: 'Podporiť',
    },

    previous: {
      title: 'Predchádzajúce testy',
    },
  },
}

export default monitorSk
